import styled from 'styled-components'
import { breakpoints, theme } from '../builderUtils/theme'

export const Header = styled.p`
  font-family: 'MatterRegular';
  color: ${theme.black};
  font-weight: 700;
  font-size: 40px;
  text-align: center;
  max-width: 90%;
  margin: 30px auto 20px;
  @media (max-width: 1100px) {
    font-size: 30px;
    line-height: 42px;
    letter-spacing: 0.15px;
    margin: 60px auto 20px;
  }
  @media (max-width: ${breakpoints.s}px) {
    margin: 20px auto 20px;
    font-size: 24px;
    line-height: normal;
  }
`

export const TestimonialSection = styled.div`
  height: 750px;
  margin: 75px 0px;
  background-color: ${theme.sky};
  @media (max-width: ${breakpoints.s}px) {
    margin: 40px 0px;
    height: 600px;
  }
`

export const Section = styled.div`
  margin: auto;
  background-color: ${theme.cream};
  text-align: left;
  .slick-slide div {
    outline: none !important;
  }
  .slick-slide {
    padding: 0px 0px 20px;
    width: 100%;
    @media (max-width: ${breakpoints.l}px) {
      padding: 40px 0px 0px;
      text-align: center;
    }
    @media (max-width: ${breakpoints.s}px) {
      width: 100%;
      padding: 20px 0px 0px;
    }
    @media (max-width: 420px) {
      height: 660px;
    }
  }
  .slick-list {
    padding: 0 20% 0 0;
  }
  .slick-center .text {
    @media (max-width: ${breakpoints.s}px) {
      min-width: 320px;
    }
  }
  .slick-center .imgContainer {
    opacity: 1;
  }
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  @media (max-width: ${breakpoints.l}px) {
    flex-wrap: wrap;
    height: auto;
  }
`

export const Text = styled.div`
  font-family: 'MatterRegular';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`

export const Card = styled.div`
  padding: 40px 45px;
  border-radius: 25px;
  box-shadow: 0px 0px 17px rgba(68, 68, 68, 0.15);
  text-align: left;
  position: relative;
  background-color: ${theme.white};
  width: 800px !important;
  margin: 0 auto;

  @media (max-width: 1300px) {
    padding: 40px 30px;
    width: 600px !important;
  }

  @media (max-width: 992px) {
    width: 500px !important;
  }

  @media (max-width: ${breakpoints.s}px) {
    text-align: center;
    padding: 25px 20px 20px;
    width: 400px !important;
  }

  @media (max-width: 450px) {
    width: 280px !important;
    margin: 0px 20px;
  }
`

export const Arrow = styled.img`
  margin: 0px 12px 0px 12px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  width: 12px;
`

export const LogoContainer = styled.div`
  width: 80px;
  margin: auto;
  opacity: 0.5;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    max-width: 80px;
    height: auto;
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 40px;
    img {
      max-width: 32px;
    }
  }
`

export const SliderContainer = styled.div`
  position: relative;
  z-index: 1;
  height: 600px;

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-slide {
    opacity: 0.5;
    transition: opacity 0.3s ease;
    > div {
      height: 100%;
    }
  }

  .slick-center {
    opacity: 1;
  }

  .slick-center #card {
    p {
      opacity: 1;
      font-size: 24px;
      line-height: 36px;
      font-family: 'MatterRegular';
      @media (max-width: ${breakpoints.m}px) {
        font-size: 16px;
        line-height: 24px;
      }
    }
    #customer {
      color: black;
      font-family: 'MatterRegular';
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px;
      @media (max-width: ${breakpoints.m}px) {
        font-size: 16px;
      }
    }
    #logo {
      opacity: 1;
    }
  }

  .slick-dots {
    position: initial;
    width: 100%;
    li {
      position: initial;
    }
  }

  .slick-dots {
    .slick-active button {
      background-color: #ffbb33;
    }
    button {
      background: white;
      border-radius: 25px;
      width: 10px;
      height: 10px;
      ::before {
        display: none;
      }
    }
  }

  @media (max-width: ${breakpoints.s}px) {
    height: 500px;
  }
`

export const LeftArrow = styled.div`
  overflow: hidden;
  position: absolute;
  top: 30%;
  left: 30px;
  z-index: 3;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  @media (max-width: 1100px) {
    top: 35%;
  }
  @media (max-width: ${breakpoints.s}px) {
    left: 0px;
    margin: 0px 0px;
    display: none;
  }
`

export const RightArrow = styled.div`
  position: absolute;
  top: 30%;
  right: 30px;
  z-index: 3;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;
  @media (max-width: 1100px) {
    top: 35%;
  }
  @media (max-width: ${breakpoints.s}px) {
    right: 0px;
    margin: 0px 0px;
    display: none;
  }
`

export const StarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${breakpoints.s}px) {
    margin-bottom: 10px;
  }
`

export const Star = styled.img`
  margin-bottom: 20px;
  display: inline-block;
  width: 32px;
  height: 32px;
  @media (max-width: ${breakpoints.s}px) {
    margin-bottom: 10px;
    width: 20px;
    height: 20px;
  }
`

export const ReviewerDetails = styled.div`
  text-align: center;
`

export const CustomerDetail = styled.p`
  color: ${theme.onboardGray};
  font-family: 'MatterRegular';
  font-size: 18px;
  font-weight: 400;
  font-style: normal;
  line-height: 150%; /* 27px */
  margin: 0px;
  @media (max-width: ${breakpoints.m}px) {
    font-size: 16px;
  }
`

export const SocialText = styled.p`
  text-align: center;
  opacity: 0.3;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 0px 0px 50px;
  font-family: 'MatterRegular';
  color: black;
  @media (max-width: ${breakpoints.m}px) {
    font-size: 16px;
    line-height: 24px;
    margin-top: 20px;
    margin: 0px 0px 30px;
  }
`

export const DetailsContainer = styled.div`
  padding: 20px 0px 0px;

  @media (max-width: ${breakpoints.m}px) {
    padding: 20px 0px 30px;
  }
`
